import { List, Paper } from "@mui/material";
import React from "react";
import { SystemValueInterface } from "../../Api/System";
import CategoryTitle from "../atoms/CategoryTitle";
import SwitchFormListItem from "../molecules/SwitchFormListItem";

interface CashRegisterSettingsProps {
    systemValue?: SystemValueInterface
    onSave?: (key: string, value: string) => void
}

const CashRegisterSettings: React.FC<CashRegisterSettingsProps> = ({
    systemValue,
    onSave
}) => {

    return (
        <Paper sx={{margin: "10px"}}>
            <CategoryTitle
                text="レジシステム関連設定"
            />
            <List>
                <SwitchFormListItem
                    text="オートレジスター機能"
                    initialValue={systemValue?.AUTO_CASH_REGISTER ? systemValue.AUTO_CASH_REGISTER === "ENABLE" : false}
                    onSave={value => {
                        if (onSave) {
                            onSave("AUTO_CASH_REGISTER", value ? "ENABLE" : "DISABLE")
                        }
                    }}
                />
            </List>
        </Paper>
    );
}

export default CashRegisterSettings